import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';

import axios from 'axios';
import { Store } from '../../../../Store';
import { toast } from 'react-toastify';
import { getError } from '../../../../utils';
import 'react-toastify/dist/ReactToastify.css';

import '../css/login.css';

const Login = ({ onRedirect }) => {
  const { dispatch: ctxDispatch } = useContext(Store);

  const location = useLocation();

  const redirectHandler = async (e) => {
    e.preventDefault();
    try {
      const { data } = await axios.get('/customer/auth/google/redirect');

      ctxDispatch({
        type: 'PREV-LINK',
        payload: location.pathname,
      });
      localStorage.setItem('resentLink', JSON.stringify(location.pathname));
      window.location.href = data.data;
    } catch (err) {
      toast.error(getError(err));
    }
  };

  return (
    <div>
      <h2 className="text-center default-box-title">Đăng nhập</h2>
      {/*<Form onSubmit={submitHandler}>
        <Form.Group className="mb-3">
          <Form.Label>
            <i className="far fa-user"></i> Tên tài khoản
          </Form.Label>
          <Form.Control
            type="text"
            placeholder="Nhập email"
            required
            onChange={(e) => setUsername(e.target.value)}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>
            <i className="fas fa-key"></i> Mật khẩu
          </Form.Label>
          <InputGroup className="mb-2">
            <Form.Control
              id="inlineFormInputGroup"
              type={showPass ? 'text' : 'password'}
              placeholder="Nhập mật khẩu"
              required
              onChange={(e) => setPassword(e.target.value)}
            />
            <InputGroup.Text onClick={() => setShowPass(!showPass)}>
              <i className={showPass ? 'far fa-eye-slash' : 'far fa-eye'}></i>
            </InputGroup.Text>
          </InputGroup>
        </Form.Group>
        <div className=" row mb-3">
          <div className="col-6">
            <Form.Check
              type="checkbox"
              id="autoSizingCheck2"
              style={{ color: 'var(--dark-gray' }}
              label="Ghi nhớ tôi"
            />
          </div>
          <div className=" col-6 d-flex justify-content-end align-items-center">
            <span>Quên mật khẩu?</span>
          </div>
        </div>
        <div className="d-flex justify-content-center align-items-center mb-3">
          <button type="submit" className="mb-2 btn-submit">
            Đăng nhập
          </button>
        </div>
      </Form>*/}
      <div className="login-with-google mb-3">
        {/*<div className="border-line d-flex justify-content-center align-items-center ">
          <div className="line"></div>
          <div className="line-text"> HOẶC </div>
          <div className="line"></div>
        </div>*/}
        <div className="d-flex justify-content-center align-items-center">
          <button
            onClick={redirectHandler}
            className="d-flex justify-content-center align-items-center"
          >
            Đăng nhập với Google{' '}
            <img
              src="/images/icons/google-logo.png"
              alt="Đăng nhập với Google"
            />
          </button>
        </div>
      </div>

      <p className="text-center m-0">
        <span>Bạn chưa có tài khoản? </span>
        <span className="registration-redirect" onClick={() => onRedirect()}>
          Đăng ký
        </span>
      </p>
    </div>
  );
};
export default Login;
